import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const API_TIMEOUT_MS = 30000;
const PARTY_HASH_MULTIPLIER = 31;

export const api = axios.create({
  baseURL: API,
  timeout: API_TIMEOUT_MS,
});

// ---- Formatters ----------------------------------------------------------
export const brl = (v) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  }).format(Number(v || 0));

export const brlPrecise = (v) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(v || 0));

export const dateBR = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

// Deterministic subtle color per political party.
const PARTY_PALETTE = [
  { bg: "#DCFCE7", fg: "#166534", border: "#BBF7D0" }, // green
  { bg: "#FEF3C7", fg: "#854D0E", border: "#FDE68A" }, // amber
  { bg: "#DBEAFE", fg: "#1E40AF", border: "#BFDBFE" }, // blue
  { bg: "#FCE7F3", fg: "#9D174D", border: "#FBCFE8" }, // pink
  { bg: "#EDE9FE", fg: "#5B21B6", border: "#DDD6FE" }, // purple
  { bg: "#FEE2E2", fg: "#991B1B", border: "#FECACA" }, // red
  { bg: "#E0F2FE", fg: "#075985", border: "#BAE6FD" }, // sky
  { bg: "#F1F5F9", fg: "#0F172A", border: "#E2E8F0" }, // slate
];

export function partyStyle(partido) {
  if (!partido) return PARTY_PALETTE[7];
  let hash = 0;
  for (let i = 0; i < partido.length; i++) {
    hash = (hash * PARTY_HASH_MULTIPLIER + partido.charCodeAt(i)) >>> 0;
  }
  return PARTY_PALETTE[hash % PARTY_PALETTE.length];
}
